import React from "react";
import Modal from "../controls/Modal";

type VideoPlayerModalProps = {
  streamUrl: string | null;
  title?: string;
  /** Rendered width/height of the map (in px) - used as a size reference for the modal/video */
  width?: number;
  height?: number;
  onDialogClose: () => void;
};

/** Renders the video tutorial player as a modal dialog, sized to roughly match the map's
 * dimensions while keeping comfortable padding around the video itself. */
const VideoPlayerModal = ({
  streamUrl,
  title,
  width,
  height,
  onDialogClose,
}: VideoPlayerModalProps) => {
  return (
    <Modal
      open={!!streamUrl}
      title={title}
      onEscPress={true}
      modalClassName="app-modal-md"
      dialogStyle={
        width
          ? { width: `${width}px`, maxWidth: "min(95vw, 960px)" }
          : undefined
      }
      bodyStyle={{ padding: "0px 14px 14px 14px" }}
      onDialogClose={onDialogClose}
    >
      <div className="w-100">
        {streamUrl && (
          <video
            controls
            autoPlay
            className="w-100 rounded"
            style={height ? { height: `${height}px`, maxHeight: "62vh" } : undefined}
            src={streamUrl}
          >
            <track kind="captions" />
          </video>
        )}
      </div>
    </Modal>
  );
};

export default VideoPlayerModal;
